// this component was automatically generated by IconGlyph.template.js
import type { FunctionComponent } from 'react';

import type { TestId } from '@trello/test-ids';

import type { IconSize } from '../src/components/Icon';
import { Icon } from '../src/components/Icon';

export interface GlyphProps {
  /**
   * A string that is applied as an aria attribute on the icon.
   */
  label?: string;
  /**
   * The color that the Icon should be rendered as.
   * @default token('color.icon', '#42526E')
   */
  color?: string;
  /**
   * The size to render the Icon size.
   * @default "medium"
   */
  size?: IconSize;
  /**
   * A string that gets placed as a data attribute (data-testid) onto the
   * Icon wrapper so that our
   * smoketest can properly target and test the component
   * @default undefined
   */
  testId?: TestId | string;
  // Escape hatches
  /**
   * ⚠️ DO NOT USE THIS PROP UNLESS YOU REALLY REALLY HAVE TO.
   *
   * Places a class name on the Icon (more specifically, the svg itself). This
   * is placed in addition to the classes already placed on the Icon. This is
   * placed directly onto the SVG via the glyph templates that are
   * generated by IconGlyph.template.js
   *
   * Please refrain from using this unless absolutely necessary.
   * @default undefined
   */
  dangerous_className?: string;
  /**
   * The switch for the icon to be centered in the dedicated space with padding around it.
   * Designed for cases when icon is not inline.
   */
  block?: boolean;
}

const MsTeamsColorIconGlyph = () => {
  return (
    <svg
      width="24"
      height="24"
      role="presentation"
      focusable="false"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.0349 10.001H16.8739L15.7129 10.94V15.597C15.7129 17.326 17.1139 18.728 18.8429 18.728C20.5729 18.728 21.9739 17.326 21.9739 15.597V10.94C21.9739 10.422 21.5539 10.001 21.0349 10.001"
        fill="#5059C9"
      />
      <path
        d="M22 7C22 8.104 21.105 9 20 9C18.895 9 18 8.104 18 7C18 5.896 18.895 5 20 5C21.105 5 22 5.896 22 7"
        fill="#5059C9"
      />
      <path
        d="M9.89214 10.0046H17.0961C17.5921 10.0046 17.9941 10.4066 17.9941 10.9026V16.5946C17.9941 19.0306 16.0201 21.0046 13.5841 21.0046H13.4041C10.9681 21.0046 8.99414 19.0306 8.99414 16.5946V10.9026C8.99414 10.4066 9.39614 10.0046 9.89214 10.0046"
        fill="#7B83EB"
      />
      <path
        d="M16.9058 6.00002C16.9058 7.60502 15.6048 8.90702 13.9988 8.90702C12.3938 8.90702 11.0928 7.60502 11.0928 6.00002C11.0928 4.39502 12.3938 3.09302 13.9988 3.09302C15.6048 3.09302 16.9058 4.39502 16.9058 6.00002"
        fill="#7B83EB"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.999 8.68124V8.00024C14.999 7.45024 14.527 7.00024 13.95 7.00024H11.27C11.687 8.09424 12.738 8.87524 13.979 8.87524C14.339 8.87524 14.681 8.80124 14.999 8.68124ZM8.99316 10.9021C8.99316 10.4061 9.39516 10.0041 9.89116 10.0041H14.9992V17.8391C14.9992 18.3891 14.3812 19.0001 13.7442 19.0001H9.71416C9.26116 18.3071 8.99316 17.4831 8.99316 16.5941V10.9021Z"
        fill="black"
      />
      <path
        d="M3 18C2.45 18 2 17.55 2 17V7C2 6.45 2.45 6 3 6H13C13.55 6 14 6.45 14 7V17C14 17.55 13.55 18 13 18H3Z"
        fill="#4B53BC"
      />
      <path
        d="M11.0004 10.0001H8.83535V15.8201H7.41235V10.0001H5.23535V8.57007H11.0004V10.0001Z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const MsTeamsColorIcon: FunctionComponent<GlyphProps> = (props) => {
  const { testId, dangerous_className, size, color, label, block } = props;
  return (
    <Icon
      testId={testId || 'MsTeamsColorIcon'}
      size={size}
      dangerous_className={dangerous_className}
      color={color}
      block={block}
      label={label}
      glyph={MsTeamsColorIconGlyph}
    />
  );
};
